module.exports = __webpack_public_path__ + "img/Kielland_Gift2.355a270d.jpg";